import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import type { PropsWithChildren } from 'react'
import { Toaster } from '@/shared/components/common/toaster'

import { AuthProvider } from '@/features/auth/auth-context'
import { queryClient } from '@/shared/api/query-client'
import { ThemeProvider } from '@/shared/providers/theme-provider'
import { RealtimeBootstrap } from '@/shared/realtime/realtime-bootstrap'
import { SupportWidgetBootstrap } from '@/shared/widget/support-widget-bootstrap'

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <RealtimeBootstrap />
          <SupportWidgetBootstrap />
          {children}
          <Toaster />
          <ReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}
